import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import FontAwesomeIcon from "../IME/Icon";
import ToggleButton from "../../PlayerButtons/ToggleButton";
// import Selector from '../Selector/Selector';
import Volume from "./Volume";
import Progress from "./Progress";

import { evaluate } from "../../../utilities/props";

const JobLiveVideo = ({ time, videoduration, showChat, profile }) => {
  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const playerRef = useRef(null);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);
  // const [, setSubtitle] = useState(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  // const options = [
  //   {
  //     label: 'Off',
  //     value: 'off'
  //   },
  //   {
  //     label: 'English',
  //     value: 'en-us'
  //   },
  //   {
  //     label: 'Spanish',
  //     value: 'es-es'
  //   },
  //   {
  //     label: 'Português',
  //     value: 'pt-br'
  //   },
  //   {
  //     label: 'Import...',
  //     value: 'new'
  //   }
  // ];
  return (
    <Fragment>
      <div className="live-stream-video-container grey" ref={playerRef}>
        <div
          className={
            showOverlay ? "alt-video-overlay" : "alt-video-overlay-pause"
          }
        >
          <div className="user-overlay-info">
            <div className="avi-container">
              <img
                // src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/employer.png`}
                className="streamer-user-avi"
              />
            </div>
            <div className="helper-container">
              <div className="stream-description-alt">
                <p className="stream-username-title">
                  <span className="blue description-font mr-10">
                    {profile.companyname}
                  </span>
                  <span className="white mr-5 description-font-alt">
                    {profile.firstname}
                  </span>
                  <span className="white description-font-alt">
                    {profile.lastname}
                  </span>
                </p>
                <p className="stream-p-description">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nam
                  ratione aut eaque dolor ea temporibus laboriosam laborum
                  recusandae odio omnis.
                </p>
                <div className="viewers">
                  <i className="fas fa-user fa-lg action-icon-user mr-5 blue"></i>
                  <span className="white bold">Views</span>{" "}
                  <span className="white bold mx-5">811,332</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              showChat
                ? "video-stream-live blue"
                : "video-stream-live-chat blue"
            }
          >
            <i className="fas fa-circle mx-5"></i>
            Live
          </div>
          <div className="alt-left-controls">
            <ul className="controls">
              <Volume
                className="Rac__volume"
                onChange={(level) => {
                  const volume = level / 100;
                  videoRef.current.volume = volume;
                  videoRef.current.muted = volume === 0;
                }}
              />
            </ul>
          </div>
          <ToggleButton
            className="alt-center-controls"
            value={() => videoRef.current && !videoRef.current.paused}
            onChange={(active) => {
              if (!active) {
                return videoRef.current.pause();
              }

              return videoRef.current.play();
            }}
          >
            {(active) => {
              if (currentTime > 0.1 && currentTime < duration && active) {
                setshowOverlay(true);
                return (
                  <i
                    className="far fa-pause-circle blue fa-4x"
                    onClick={() => videoRef.current.pause()}
                  ></i>
                );
              } else {
                setshowOverlay(false);
              }
              if (currentTime === duration) {
                setCurrentTime(0);
              } else if (currentTime === 0 && !active) {
                return (
                  <i
                    className="far fa-play-circle blue fa-4x"
                    onClick={() => videoRef.current.play()}
                  ></i>
                );
              }
              return (
                <i
                  className="far fa-play-circle blue fa-4x"
                  onClick={() => videoRef.current.play()}
                ></i>
              );
            }}
          </ToggleButton>
          <Progress
            className="Rac__progress-bar"
            initial={0}
            time={currentTime}
            duration={duration}
            onSkip={(time) => (videoRef.current.currentTime = time)}
          />
          <div className="icon-flex-expand-settings">
            <ToggleButton
              className="Rac__screen-toggle"
              initial={document.fullscreenElement}
              onChange={(active) => {
                if (!active && KeyboardEvent.key === "Escape") {
                  return document.exitFullscreen();
                }

                return playerRef.current.requestFullscreen({
                  navigationUI: "hide",
                });
              }}
            >
              {(active) => {
                if (!active) {
                  return (
                    <FontAwesomeIcon
                      icon="expand"
                      size="lg"
                      className="mt-4 blue"
                    />
                  );
                }

                if (active) {
                  return (
                    <FontAwesomeIcon
                      icon="compress"
                      size="lg"
                      className="mt-4 blue"
                    />
                  );
                }
              }}
            </ToggleButton>
            <ToggleButton className="">
              {(showSettings) => {
                if (showSettings) {
                  return (
                    <div className="relative-button-container">
                      <li className="control blue">
                        <i className="fas fa-cog fa-lg icon-padding"></i>
                      </li>
                      <div className="video-settings">
                        <ul className="video-setting">
                          <li className="video-option blue bold">Quality</li>
                          <li className="video-option white cursor">
                            Auto
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option blue bold">Caption</li>
                          <li className="video-option white cursor">
                            Off
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option blue bold">
                            Report Issue
                          </li>
                          <li className="video-option white cursor">
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option blue bold">Advanced</li>
                          <li className="video-option white cursor">
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  );
                }

                return (
                  <div className="relative-button-container">
                    <li className="control blue">
                      <i className="fas fa-cog fa-lg icon-padding"></i>
                    </li>
                  </div>
                );
              }}
            </ToggleButton>
          </div>
        </div>
        <video
          ref={videoRef}
          src={
            "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_140936.mp4"
          }
          className="fill-video"
        ></video>
      </div>
    </Fragment>
  );
};

JobLiveVideo.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
};

export default JobLiveVideo;
